import React, { useRef, useState } from "react";
import ArrowIcon from "@ancon/wildcat-ui/shared/icons/arrow-back-long.svg";

import styles from "./OrderCollectSlider.module.scss";
import BodyText from "../support/BodyText";

const SLIDER_THUMB_DIAMETER = 45;
const SLIDER_MAX_VALUE = 100;
const SLIDER_MIN_VALUE = 0;

export default function OrderCollectSlider() {
  const [sliderValue, setSliderValue] = useState(0);
  const sliderTrackRef = useRef<HTMLDivElement | null>(null);
  const sliderThumbRef = useRef<HTMLDivElement | null>(null);
  const SLIDER_TRACK_WIDTH = 290;

  const isCollected = sliderValue === SLIDER_MAX_VALUE;

  function handleSlideChange(e: React.ChangeEvent<HTMLInputElement>) {
    const value = parseInt(e.target.value, 10);
    const sliderProgress = (SLIDER_TRACK_WIDTH / SLIDER_MAX_VALUE) * value;

    setSliderValue(value);

    if (sliderValue === SLIDER_MAX_VALUE) {
      return;
    }

    sliderTrackRef.current!.style.width = `${
      sliderProgress + SLIDER_THUMB_DIAMETER
    }px`;
    sliderThumbRef.current!.style.left = `${sliderProgress}px`;

    if (value === SLIDER_MAX_VALUE) {
      // TODO: On complete
    }
  }

  function handleSlideStop() {
    setTimeout(() => {
      setSliderValue(SLIDER_MIN_VALUE);
      if (sliderValue !== SLIDER_MAX_VALUE) {
        sliderTrackRef.current!.style.width = `${SLIDER_THUMB_DIAMETER}px`;
        sliderThumbRef.current!.style.left = `${SLIDER_MIN_VALUE}px`;
      }
    }, 0);
  }

  return (
    <div className={styles.sliderContainer}>
      <BodyText color="body-1" className={styles.sliderPreText}>
        Mark as issued by cashier / waiter
      </BodyText>
      <div className={styles.sliderProgress} ref={sliderTrackRef}>
        <BodyText color="body-3">Items are issued</BodyText>
      </div>
      <div className={styles.rangeSlider}>
        <input
          type="range"
          max={SLIDER_MAX_VALUE}
          min={SLIDER_MIN_VALUE}
          value={sliderValue}
          className={styles.sliderInput}
          disabled={isCollected}
          onInput={handleSlideChange}
          onMouseUp={handleSlideStop}
        />
        <div className={styles.sliderThumb} ref={sliderThumbRef}>
          <ArrowIcon />
        </div>
      </div>
    </div>
  );
}
